var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"margin":"0","padding":"0"},attrs:{"fluid":""}},[_c('div',{staticClass:"mb-1",staticStyle:{"background-color":"white"}},[_c('select-accounts')],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }